import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { TranslationService } from '@services/translation/translation.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { DefaultFormComponent } from '../../../components/default-form/default-form.component';
import { FormComponent } from '../../../components/default-form/form.component';
import { FormDirective } from '../../../directives/form/form.directive';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-translation-edit',
  templateUrl: './translation-edit.component.html',
  styleUrls: ['./translation-edit.component.scss'],
  providers: [TranslationService],
  standalone: false
})

export class TranslationEditComponent implements OnInit {
  @ViewChild(FormDirective, { static: true }) formHost: FormDirective;
  options = { hideFields: false };
  public subtitle = '';
  public pageActions: PageAction[];
  translation: Models.Translation;
  isLoading = false;
  translationId;

  constructor(
    public translationService: TranslationService, private route: ActivatedRoute,
    private router: Router,
    private componentFactoryResolver: ComponentFactoryResolver, private snackbar: SnackbarService
  ) {

  }

  ngOnInit() {
    this.isLoading = true;
    if (this.route.snapshot.params['id']) {
      this.translationId = this.route.snapshot.params['id'];
      this.initExisting();
    } else {
      this.initNew();
    }
    this.createPageActions();
  }

  onSave() {
    return this.translation.validate(true).then(result => {
      let valid = true;
      try {
        JSON.parse(this.translation.data);
      } catch (err) {
        valid = false;
      }
      if (result.success && valid) {
        if (this.translationId) {
          this.translationService.patch(this.translationId, this.translation).then(translationResult => {
            this.snackbar.success('Saved changes successfull');
          });
        } else {
          this.translationService.create(this.translation).then(translationResult => {
            this.afterSave(translationResult);
            this.snackbar.success('Saved new entry successfull');
          });
        }
      } else {
        console.log(result);
        this.snackbar.open('Could not create the Translation, please fill in the form correctly');
      }
    });
  }

  private initExisting() {
    this.translationService.get(this.translationId).then(translation => {
      this.translation = translation;
      this.loadForm();
    });
  }

  private initNew() {
    this.isLoading = false;
    this.translation = <Models.Translation>Models.ModelFactory.createModelInstanceByName('Translation');
    this.loadForm();
  }

  private loadForm() {
    const formItem = DefaultFormComponent;
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(formItem);
    const viewContainerRef = this.formHost.viewContainerRef;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<FormComponent>componentRef.instance).entry = this.translation;
    (<FormComponent>componentRef.instance).options = this.options;
    this.isLoading = false;
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left', translationString: 'general.back', callback: () => {
          this.router.navigate(['translation'])
        }
      } as any),
      new PageAction({
        icon: 'save', translationString: 'general.save', callback: () => {
          this.onSave()
        }
      } as any)
    ];
  }

  private afterSave(translation) {
    this.translationId = translation._id;
    this.initExisting();
  }
}
